import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { Wordmark } from "@/components/Navbar";

const serviceLinks = [
  "Personal Care Assistance",
  "Home Health Aide Services",
  "Skilled Nursing",
  "Private Duty Nursing",
  "Companion & Support Services",
  "Family & Caregiver Support",
];

const quickLinks = [
  { to: "/", label: "Home", testid: "footer-link-home" },
  { to: "/services", label: "Our Services", testid: "footer-link-services" },
  { to: "/careers", label: "Careers", testid: "footer-link-careers" },
  { to: "/request-care", label: "Request Care", testid: "footer-link-request-care" },
  { to: "/contact", label: "Contact", testid: "footer-link-contact" },
];

const Footer = () => (
  <footer data-testid="site-footer" className="bg-white">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="h-px w-full bg-gradient-to-r from-transparent via-gold/50 to-transparent" />
    </div>
    <div className="mx-auto grid max-w-7xl gap-12 px-5 py-16 sm:px-8 lg:grid-cols-[1.4fr_1fr_1fr_1.2fr]">
      <div>
        <Wordmark className="h-20" />
        <p
          data-testid="footer-tagline-text"
          className="mt-5 font-serif text-xl italic text-gold-deep"
        >
          Compassionate Care. New Beginnings.
        </p>
        <p className="mt-4 max-w-xs text-sm leading-relaxed text-charcoal-muted">
          Dependable, personalized home healthcare supporting individuals and
          families throughout New Jersey.
        </p>
      </div>

      <div>
        <h3 className="overline-gold mb-5">Explore</h3>
        <ul className="space-y-3">
          {quickLinks.map((l) => (
            <li key={l.to}>
              <Link
                to={l.to}
                data-testid={l.testid}
                className="text-sm text-charcoal-light transition-colors hover:text-gold-deep"
              >
                {l.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div>
        <h3 className="overline-gold mb-5">Services</h3>
        <ul className="space-y-3">
          {serviceLinks.map((s) => (
            <li key={s}>
              <Link
                to="/services"
                className="text-sm text-charcoal-light transition-colors hover:text-gold-deep"
              >
                {s}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <div>
        <h3 className="overline-gold mb-5">Contact</h3>
        <ul className="space-y-4 text-sm text-charcoal-light">
          <li className="flex items-start gap-3">
            <Phone className="mt-0.5 h-4 w-4 shrink-0 text-gold" strokeWidth={1.5} />
            <a href="tel:+18565457393" data-testid="footer-phone" className="transition-colors hover:text-gold-deep">
              (856) 545-7393
            </a>
          </li>
          <li className="flex items-start gap-3">
            <Mail className="mt-0.5 h-4 w-4 shrink-0 text-gold" strokeWidth={1.5} />
            <a href="mailto:Newbeginningshealthcarenj@gmail.com" data-testid="footer-email" className="text-xs transition-colors hover:text-gold-deep">
              Newbeginningshealthcarenj@gmail.com
            </a>
          </li>
          <li className="flex items-start gap-3">
            <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-gold" strokeWidth={1.5} />
            <span>Serving families across New Jersey</span>
          </li>
        </ul>
      </div>
    </div>
    <div className="border-t border-blush-200 bg-blush-50/60 py-6">
      <p className="mx-auto max-w-7xl px-5 text-center text-xs text-charcoal-faint sm:px-8">
        &copy; {new Date().getFullYear()} New Beginnings Healthcare Services, LLC. All rights reserved. Licensed &amp; insured in the State of New Jersey.
      </p>
    </div>
  </footer>
);

export default Footer;
